import { useEffect } from "react";
import { useSelector } from "react-redux";
import { InputOnChangeData } from "semantic-ui-react";
import { getDomains } from "../../../../../selectors/projects";
import { getZoneidFromRegionName } from "../../../../../app_shared_functions";

type UseResetOnRegionChangeProps = {
  region: string;
  handleInputChange: (
    event: React.FormEvent<HTMLInputElement>,
    data: InputOnChangeData,
  ) => void;
};

const useResetOnRegionChange = ({
  region,
  handleInputChange,
}: UseResetOnRegionChangeProps) => {
  const domains = useSelector(getDomains);

  useEffect(() => {
    if (region) {
      const key = getZoneidFromRegionName(region, domains);
      const defaultCIDR = `10.${key}.0.0/24`;

      handleInputChange(
        {} as React.FormEvent<HTMLInputElement>,
        { name: "cidr", value: defaultCIDR } as InputOnChangeData,
      );
      handleInputChange(
        {} as React.FormEvent<HTMLInputElement>,
        { name: "selectedNetwork", value: "" } as InputOnChangeData,
      );
      handleInputChange(
        {} as React.FormEvent<HTMLInputElement>,
        {
          name: "selectedSubnetPoolId",
          value: "",
        } as InputOnChangeData,
      );
    }
  }, [region, handleInputChange, domains]);
};

export default useResetOnRegionChange;
